import React from 'react';
import { Switch, Route } from "react-router-dom";
import FoodCourtHome from "screens/FoodCourt/Home/FoodCourtHome";
import FoodCourtDetail from "screens/FoodCourt/Detail/FoodCourtDetail";

function FoodCourt(props) {
    return (
        <Switch>  
            <Route path={`${props.match.url}`} exact component={FoodCourtHome}/>
            <Route path={ `${props.match.url}/:id` } exact component={FoodCourtDetail}/>
        </Switch>
    )
}

export default FoodCourt
                                                            